import React from 'react';
import PropTypes from 'prop-types';

const folder = 'https://cdn.fanatical.com/production/product/payment-methods-cart/svg';

export default function PaymentIcon({ type }) {
  let icon = null;

  if (type === 'visa') {
    icon = <img key={type} loading="lazy" src={`${folder}/visa_2021.svg`} alt="VISA" className={type} height="100%" width="100%" />;
  }
  if (type === 'mastercard') {
    icon = <img key={type} loading="lazy" src={`${folder}/mastercard.svg`} alt="Master Card" className={type} height="100%" width="100%" />;
  }
  if (type === 'american-express') {
    icon = <img key={type} loading="lazy" src={`${folder}/american-express.svg`} alt="American Express" className={type} height="100%" width="100%" />;
  }
  if (type === 'paypal') {
    icon = <img key={type} loading="lazy" src={`${folder}/paypal.svg`} alt="PayPal" className={type} height="100%" width="100%" />;
  }
  if (type === 'googlepay') {
    icon = <img key={type} loading="lazy" src={`${folder}/googlepay.svg`} alt="Google Pay" className={type} height="100%" width="100%" />;
  }
  if (type === 'alipay') {
    icon = <img key={type} loading="lazy" src={`${folder}/alipay.svg`} alt="Alipay" className={type} height="100%" width="100%" />;
  }
  if (type === 'applepay') {
    icon = <img key={type} loading="lazy" src={`${folder}/applepay.svg`} alt="Apple Pay" className={type} height="100%" width="100%" />;
  }
  if (type === 'cartebancaire') {
    icon = <img key={type} loading="lazy" src={`${folder}/cartebancaire.svg`} alt="Cartes Bancaires" className={type} height="100%" width="100%" />;
  }
  if (type === 'discover') {
    icon = <img key={type} loading="lazy" src={`${folder}/discover.svg`} alt="Discover" className={type} height="100%" width="100%" />;
  }
  if (type === 'jcb') {
    icon = <img key={type} loading="lazy" src={`${folder}/jcb.svg`} alt="JCB" className={type} height="100%" width="100%" />;
  }
  if (type === 'ideal') {
    icon = <img key={type} loading="lazy" src={`${folder}/ideal.svg`} alt="ideal" className={type} height="100%" width="100%" />;
  }
  if (type === 'sofort') {
    icon = <img key={type} loading="lazy" src={`${folder}/sofort.svg`} alt="sofort" className={type} height="100%" width="100%" />;
  }
  if (type === 'unionpay' || type === 'cup') {
    icon = <img key={type} loading="lazy" src={`${folder}/unionpay.svg`} alt="UnionPay" className={type} height="100%" width="100%" />;
  }
  if (type === 'maestro') {
    icon = <img key={type} loading="lazy" src={`${folder}/maestro.svg`} alt="Maestro" className={type} height="100%" width="100%" />;
  }
  if (type === 'diners') {
    icon = <img key={type} loading="lazy" src={`${folder}/diners.svg`} alt="Diners Club" className={type} height="100%" width="100%" />;
  }
  if (type === 'qiwi') {
    icon = <img key={type} loading="lazy" src={`${folder}/qiwi.svg`} alt="qiwi" className={type} height="100%" width="100%" />;
  }
  if (type === 'wechatpayQR') {
    icon = <img key={type} loading="lazy" src={`${folder}/wechatpayQR.svg`} alt="wechatpayQR" className={type} height="100%" width="100%" />;
  }

  if (!icon) return false;
  return icon;
}

PaymentIcon.propTypes = {
  type: PropTypes.string.isRequired,
};
